import ErrorContent from "App/errorBoundaries/ErrorContent";
import React from "react";

export const UnexpectedError = () => {
  return <ErrorContent />;
};
